module.exports = __webpack_public_path__ + "img/emoji/thonkwat.0b86efb8e7292b9c0188e32ea5d20dbf.png";